import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useState } from 'react';
import cx from 'classnames';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Loader } from 'panamera-react-ui';
import { withComponentDependency } from "../../ComponentDependency/withComponentDependency";
var css = {
  "o2oLink": "oalp-2eeE7",
  "linkSeperator": "oalp-2mQ3b",
  "sep": "oalp-3En0T",
  "seperatorMobile": "oalp-1iacj",
  "loader": "oalp-3QuJj",
  "hide": "oalp-1KKT7"
};
import { setValuatonRegistraionResponse } from "../../Store/Actions/layout";
import { HOW_TO_SELL_CAR_WIDGET_NUMBER_PLATE_LINK_NAME } from "../../Constants/templateName";
import TrackingInfoManager from "../../Utils/TrackingInfoManager";
import { UNKNOWN } from "../../Constants/locations";
import { getTrackingOrigin } from "../../Store/Selectors/layout";
import { withRouter } from "../../Helpers/withRouter";
import withConfig from "../../ComponentDependency/withConfig";
export var NumberPlateInputWithLink = function NumberPlateInputWithLink(_ref) {
  var data = _ref.data,
    NumberPlate = _ref.NumberPlate,
    metadata = _ref.metadata,
    toggleShowAllCTA = _ref.toggleShowAllCTA,
    track = _ref.track,
    locationId = _ref.locationId,
    browsingMode = _ref.browsingMode,
    origin = _ref.origin,
    config = _ref.config,
    router = _ref.router;
  var link = data.link,
    numberPlateProps = data.numberPlateProps,
    seperator = data.seperator,
    parentWidgetName = data.parentWidgetName;
  var _ref2 = metadata || {},
    style = _ref2.style,
    trackingInfo = _ref2.trackingInfo;
  var trackingClickEventName = trackingInfo && trackingInfo.clickEvent && trackingInfo.clickEvent.name;
  var _ref3 = seperator || {},
    seperatorStyle = _ref3.style,
    _ref3$className = _ref3.className,
    seperatorClass = _ref3$className === void 0 ? 'sep' : _ref3$className;
  var _link$actionUrl = link.actionUrl,
    actionUrl = _link$actionUrl === void 0 ? '' : _link$actionUrl,
    text = link.text,
    linkStyle = link.style,
    name = link.name;
  var trackingInfoObj = TrackingInfoManager.getTrackingInfo({
    browsing_location_id: locationId || UNKNOWN,
    browsing_mode: browsingMode,
    origin: origin
  });
  var handleClick = useCallback(function () {
    if (name === HOW_TO_SELL_CAR_WIDGET_NUMBER_PLATE_LINK_NAME) {
      router === null || router === void 0 ? void 0 : router.push(config.get('landingPageRoutes', 'sell-organic'));
      toggleShowAllCTA(false);
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
      if (track && trackingClickEventName) {
        track(trackingClickEventName, trackingInfoObj);
      }
    } else {
      router === null || router === void 0 ? void 0 : router.push(actionUrl);
    }
  }, [name, toggleShowAllCTA, track, trackingClickEventName, trackingInfoObj, router, config]);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    registrationNumber = _useState2[0],
    setRegistrationNumber = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  return /*#__PURE__*/React.createElement("div", {
    style: style
  }, !!NumberPlate && /*#__PURE__*/React.createElement(NumberPlate, {
    registrationNumber: registrationNumber,
    setRegistrationNumber: setRegistrationNumber,
    numberPlateProps: numberPlateProps,
    parentWidgetName: parentWidgetName,
    setValuatonRegistraionResponse: setValuatonRegistraionResponse,
    track: track,
    trackingInfoObj: trackingInfoObj,
    trackingEventName: trackingClickEventName,
    setIsLoading: setIsLoading,
    numberPlateContainerClassName: isLoading ? css.hide : ''
  }), isLoading && /*#__PURE__*/React.createElement(Loader, {
    containerSize: "50px",
    stroke: "4px",
    className: css.loader
  }), link && /*#__PURE__*/React.createElement("div", {
    className: css.o2oLink
  }, /*#__PURE__*/React.createElement("hr", {
    style: seperatorStyle,
    className: cx(css.linkSeperator, css[seperatorClass])
  }), /*#__PURE__*/React.createElement("div", {
    "data-aut-id": "o2o-link",
    style: linkStyle,
    onClick: handleClick
  }, text)));
};
export var mapStateToProps = function mapStateToProps(state, props) {
  return {
    browsingMode: state.track.browsingMode,
    origin: getTrackingOrigin(state, props.location == null ? null : props.location, props.config)
  };
};
export var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    toggleShowAllCTA: function toggleShowAllCTA(flag) {
      return dispatch({
        type: 'UPDATE_SHOW_ALL_HP',
        value: flag
      });
    }
  };
};
export default compose(withConfig, withRouter, withComponentDependency, connect(mapStateToProps, mapDispatchToProps))(NumberPlateInputWithLink);